module.exports = __webpack_public_path__ + "img/sketch-about-us.f0c84698.svg";